import type { RouteRecordRaw } from 'vue-router';

export const expensesRoutes: RouteRecordRaw[] = [
  {
    path: 'expenses',
    name: 'expenses',
    component: () => import('./pages/ExpensesListPage.vue'),
    meta: { title: 'Expenses', requiresAuth: true, permission: 'view_expenses' },
  },
  {
    path: 'expenses/new',
    name: 'expenses.create',
    component: () => import('./pages/CaptureExpensePage.vue'),
    meta: { title: 'Capture receipt', requiresAuth: true },
  },
  // Batch invoice import — declared before `expenses/:id` so the static
  // segments win the match.
  {
    path: 'expenses/import',
    name: 'expenses.import',
    component: () => import('./pages/ImportExpensesPage.vue'),
    meta: { title: 'Import invoices', requiresAuth: true, permission: 'import_expenses' },
  },
  {
    path: 'expenses/imports',
    name: 'expenses.imports',
    component: () => import('./pages/ImportHistoryPage.vue'),
    meta: { title: 'Import history', requiresAuth: true, permission: 'import_expenses' },
  },
  {
    path: 'expenses/imports/:id',
    name: 'expenses.imports.show',
    component: () => import('./pages/ImportBatchDetailPage.vue'),
    meta: { title: 'Import batch', requiresAuth: true, permission: 'import_expenses' },
  },
  // Managed spend categories — static segment declared before `expenses/:id`.
  {
    path: 'expenses/categories',
    name: 'expenses.categories',
    component: () => import('./pages/ExpenseCategoriesPage.vue'),
    meta: { title: 'Expense categories', requiresAuth: true },
  },
  {
    path: 'expenses/:id',
    name: 'expenses.show',
    component: () => import('./pages/ExpenseDetailPage.vue'),
    meta: { title: 'Expense', requiresAuth: true },
  },
];
